/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {UserDetailsUpdateModel} from "../../models/user-details-update-model";


export interface UserUpdateParams {
    userGuid: string;
    body: UserDetailsUpdateModel
}

export function userUpdate(http: HttpClient, rootUrl: string, params: UserUpdateParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, userUpdate.PATH, 'put');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    if (params) {
        rb.path('userGuid', params.userGuid, {"style":"simple"});
        rb.body(params.body, 'application/json');
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<void>;
        })
    );
}

userUpdate.PATH = '/api/v1/users/{userGuid}';
